import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook, Twitter, BookOpen, ShoppingBag } from "lucide-react";
import { getAuthor } from "@/lib/api";
import Newsletter from "@/components/Newsletter";

export default function About() {
  const [author, setAuthor] = useState(null);
  useEffect(() => {
    getAuthor().then(setAuthor).catch(() => {});
  }, []);

  if (!author) return <div className="pt-40 pb-40 text-center text-zinc-600">Loading…</div>;

  return (
    <div data-testid="about-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-28">
        <div className="grid lg:grid-cols-5 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 lg:sticky lg:top-28"
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-amber-500/10 blur-2xl" />
              <img src={author.portrait} alt={author.name} className="relative w-full aspect-[4/5] object-cover border border-zinc-800" />
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              {[
                { key: "instagram", Icon: Instagram },
                { key: "facebook", Icon: Facebook },
                { key: "twitter", Icon: Twitter },
                { key: "goodreads", Icon: BookOpen },
                { key: "amazon", Icon: ShoppingBag },
              ].filter((s) => author.socials?.[s.key]).map(({ key, Icon }) => (
                <a key={key} href={author.socials[key]} target="_blank" rel="noreferrer" data-testid={`about-${key}`} className="h-11 w-11 grid place-items-center border border-zinc-800 text-zinc-400 hover:text-amber-500 hover:border-amber-500 transition-colors"><Icon size={18} /></a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-3"
          >
            <p className="text-xs tracking-accent uppercase text-amber-500 mb-4">About</p>
            <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight leading-[1.05]">
              Hello, I'm <span className="text-amber-500">{author.name}</span>
            </h1>
            <p className="mt-8 text-xl text-zinc-200 leading-relaxed font-display italic">{author.tagline}</p>
            <div className="mt-8 space-y-6 text-zinc-300 leading-relaxed text-lg">
              <p>{author.bio_short}</p>
              {author.bio_long.split("\n\n").map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
